<list [id]="list.id" class="{{highlightStyles}}"  [list]="list"></list>